export const conversationTabs = [
  'rpm',
  'ccm',
  'unregistered_rpm',
  'unregistered_ccm',
];
export const registeredConversationTabs = ['rpm', 'ccm'];
